module.exports = __webpack_public_path__ + "img/kt-kgk.d8f40f24.png";